import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pconstruct(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Constructor Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python constructor tutorial for beginners.A constructor is a special method invoked automatically and A constructor is mainly used to initialize the object" />
<meta name="keywords" content="python class constructor,python constructor example,python constructor overloading,python constructor arguments,python constructor super,python constructor class" />
<link rel="canonical" href="https://www.codeexampler.com/python-constructor"/>
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Python Constructor</h1>

    <div className="first">
        <a href="/python-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-searching">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <p className="mt-4 para"><span className="bold">python class constructor: </span>A constructor is a unique method invoked automatically<br/>
    A constructor is mainly used to initialize the object<br/>
    </p>
<h2 className="mt-4 mh2">python class constructor Syntax is given below:</h2>
 


       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty">def </span>
                <span className="qwerty-4">--init--</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-5">self</span>
                <span className="qwerty-1">)</span>
                <span className="qwerty-1">:</span>
                <span className="qwerty-10"> ------</span>
                <span className="qwerty-3">this is a constructor</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>


<h3 className="mt-4 ">If you add new attributes in the python class constructor</h3>


       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-4">emp1</span>
                <span className="qwerty">.</span>
                <span className="qwerty-7">dept</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-2">sales</span>
                <span className="qwerty-6">'</span>
            {"\n"}
                <span className="qwerty-4">emp2</span>
                <span className="qwerty">.</span>
                <span className="qwerty-7">dept</span>
                <span className="qwerty-1"> = </span>
                <span className="qwerty-6">'</span>
                <span className="qwerty-2">sales</span>
                <span className="qwerty-6">'</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>  

  <h1 className="mt-5">  </h1>
      <h1 className="mt-5">  </h1>
      <div className="back">
        <a href="/python-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-searching">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pconstruct;